import { MerchantStore } from '@bringg-frontend/global-stores';
export default MerchantStore;
